export const IS_SAFARI = (() => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') === -1) {
            return true; // Safari
        }
    }
    return false;
})();
export const IS_IE = navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/));
export const REQUIRES_FORMS = false;
